import * as React from "react";
import EdButton, { IEdButtonProps } from "./edButton";
import "../../assets/scss/components/generic/cancel_T_Record.scss";

export interface ICANCEL_T_RECORDProps {
	title: string;
	subtitle?: string;
	btnProps: IEdButtonProps;
}

export function CANCEL_T_RECORD(props: ICANCEL_T_RECORDProps) {
	return (
		<div className="cancel_T_mes_popup_con cancel taCenter">
			<h2 className="cancel_T_tit">{props.title}</h2>
			{props.subtitle && <h3 className="cancel_T_sub_tit">{props.subtitle}</h3>}
			<div className="cancel_T_btn">
				<EdButton value={props.btnProps.value} btnTyp={props.btnProps.btnTyp} onClick={props.btnProps.onClick} slim />
			</div>
		</div>
	);
}
